import { Injectable } from '@angular/core';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { initFeatureStoreKey } from '../feature/init.feature';
import { InitState } from '../state/init.state';

export const getInitState =
  createFeatureSelector<InitState>(initFeatureStoreKey);

export const getAccountInfo = createSelector(
  getInitState,
  (state) => state.accountInfo,
);

export const getUserInfoLoaded = createSelector(
  getInitState,
  (state) => state.isUserInfoLoaded,
);

export const getUserId = createSelector(
  getInitState,
  (state) => state.accountInfo?.custId,
);

@Injectable({
  providedIn: 'root',
})
export class InitSelectors {
  getAccountInfo$ = this.store.select(getAccountInfo);
  isUserInfoLoaded$ = this.store.select(getUserInfoLoaded);
  getUserId$ = this.store.select(getUserId);

  constructor(private store: Store<InitState>) {}
}
